export default __webpack_public_path__ + "static/media/Sorcerer's Dread.aaeecef1.jpg";